/** axios封装升级后的http.js */

/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import router from '../router'// 引入路由用来跳转
// import store from '../store/index' // 引入Vuex用来获取状态
import constant from '../utils/constant'

// 路由前置名
const pathPre = constant.pathPre

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: pathPre + '/Login/Index',
    query: {
      redirect: router.currentRoute.fullPath
    }
  })
}

let hasErrorOneTime = false // 是否第一次报错

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // console.log(status, other)
  // 状态码判断
  switch (status) {
    // 这里根据你们项目中的具体返回的  状态码  进行编写。
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin()
      break
      // 403 token过期
      // 清除token并跳转登录页
    case 403:
      // tip('登录过期，请重新登录') // 调用提示函数
      // 清楚token
      // localStorage.removeItem('token')
      // store.commit('loginSuccess', null) // 将Vuex中的token赋值为null
      // 1s后跳转登录页
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
      // 404请求不存在
    case 404:
      // tip('请求的资源不存在')
      break
    default:
      console.log(other)
  }
}
axios.defaults.withCredentials = true
// 创建axios实例
// 如果请求花费了超过 `timeout` 的时间，请求将被中断
var instance = axios.create({timeout: 1000 * 12})
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  // config 为axios实例后的的请求配置信息。
  config => {
    if (sessionStorage.getItem('token')) {
      // token字段是要和后端协商好的
      config.headers.common['token'] = sessionStorage.getItem('token')
    }
    return config
  },
  // error 为错误信息
  error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功 (又分为是否正常返回数据)
  res => {
    if (res.data.msg === 'Token验证不通过') {
      if (!hasErrorOneTime) {
        constant.giveMessage(res.data.msg + '，请重新登录！', 'error')
        hasErrorOneTime = true
      }
      router.replace({
        path: pathPre + '/Login/index'
      })
    }
    // store.commit('changeIsLoading', false) // 关闭loading
    return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
  },
  // 请求失败
  error => {
    // store.commit('changeIsLoading', false) // 关闭loading
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message) // 调用错误处理函数。
      return Promise.reject(response) // 依然返回错误的信息
    } else {
      // 处理断网的情况
      // 跳转到断网处理页面
      // 在这个页面一般会有点击刷新，要在返回到用户原来停留的页面。
      router.replace({
        path: pathPre + '/Login/index',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }
  })

// 暴露出封装的axios实例
export default instance



// WEBPACK FOOTER //
// ./src/utils/http.js